module.exports = __webpack_public_path__ + "static/media/VideosInactive.c6f2eda9.png";